// extracted by mini-css-extract-plugin
export default {"caption":"Select_caption__r1PVK"};